import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    registrationId: String,
    runUrl: String
  }

  static targets = ["runButton", "readyAlert"]

  connect() {
    console.log("Integration runner controller connected")
  }

  async runAll(event) {
    event.preventDefault()

    // Disable button and show loading state
    if (this.hasRunButtonTarget) {
      this.runButtonTarget.disabled = true
      this.runButtonTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Uruchamianie...'
    }

    try {
      const response = await fetch(`${this.runUrlValue}?run_all=true`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        console.log("Integrations started:", data)

        // Show success message - replace the ready alert with processing info
        if (this.hasReadyAlertTarget) {
          this.readyAlertTarget.classList.remove('alert-secondary')
          this.readyAlertTarget.classList.add('alert-info')
          this.readyAlertTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Integracje zostaly uruchomione. Prosze czekac...<br><small class="text-muted">Strona zaktualizuje sie automatycznie.</small>'
        }

        // Hide the run button
        if (this.hasRunButtonTarget) {
          this.runButtonTarget.style.display = 'none'
        }
      } else {
        // Error - re-enable button
        console.error("Failed to start integrations")
        if (this.hasRunButtonTarget) {
          this.runButtonTarget.disabled = false
          this.runButtonTarget.innerHTML = 'Uruchom wszystkie'
        }
        alert('Wystapil blad podczas uruchamiania integracji.')
      }
    } catch (error) {
      console.error("Error starting integrations:", error)
      if (this.hasRunButtonTarget) {
        this.runButtonTarget.disabled = false
        this.runButtonTarget.innerHTML = 'Uruchom wszystkie'
      }
      alert('Blad polaczenia. Sprobuj ponownie.')
    }
  }

  get csrfToken() {
    const meta = document.querySelector('[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}
